webpackJsonp([31],{

/***/ 1009:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1010:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1011:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_apiurl_json__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_apiurl_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_apiurl_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_crip_vue_notice__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_crip_vue_notice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_crip_vue_notice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_service_pos__ = __webpack_require__(498);





var numeral = __webpack_require__(1014);
var moment = __webpack_require__(3);
var ThaiBaht = __webpack_require__(1015);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_crip_vue_notice___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin({
  data: function data() {
    return {
      REST_URL: __WEBPACK_IMPORTED_MODULE_2__static_apiurl_json___default.a.api,
      PRINTER_HOST: __WEBPACK_IMPORTED_MODULE_2__static_apiurl_json___default.a.printer_url
    };
  },

  methods: {
    checkUser: function checkUser() {
      this.$store.state.currentPath = this.$route.path;
      if (sessionStorage.user) {
        this.$store.state.token = sessionStorage.token;
        this.$store.state.user = JSON.parse(sessionStorage.user);
        this.getConfig();
      } else {
        this.$router.push('/login');
      }
    },
    getConfig: function getConfig() {
      var _this = this;

      var body = {};
      __WEBPACK_IMPORTED_MODULE_4__services_service_pos__["a" /* default */].configDetail(this.REST_URL, this.header, body, function (result) {
        if (result.response === 'success') {
          sessionStorage.config = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.data);
          _this.$store.state.config = result.data;
          localStorage.setItem('config', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.data));
        } else {
          _this.$notification['warning']({
            message: 'ดึงข้อมูลจุดขายไม่ได้',
            description: result.message
          });
        }
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    getListHostDetail: function getListHostDetail(data, afterSuccess) {
      var _this2 = this;

      sessionStorage.hostshift = undefined;
      var body = { 'host_code': data.host_code };
      __WEBPACK_IMPORTED_MODULE_4__services_service_pos__["a" /* default */].getHostShiftDetail(this.REST_URL, this.header, body, function (result) {
        if (result.response === 'success') {
          sessionStorage.hostshift = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.data);
          _this2.$router.push('/pos');
          if (typeof afterSuccess === 'function') {
            afterSuccess();
          }
        } else {
          _this2.$notification['warning']({
            message: 'ดึงข้อมูลจุดขายไม่ได้',
            description: result.message
          });
        }
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    openCashBox: function openCashBox(data) {
      var _this3 = this;

      var body = { 'host_code': data.host_code, 'printer_port': data.printer_port };
      __WEBPACK_IMPORTED_MODULE_4__services_service_pos__["a" /* default */].openCashBox(this.REST_URL, body, this.header, function (result) {
        if (result.response === 'success') {
          _this3.alert_msg('success', 'แจ้งเตือนระบบ', 'เปิดกล่องเก็บเงินเรียบร้อย');
        } else {
          // this.alert_msg('warning', 'แจ้งเตือนระบบ', 'เปิดกล่องเก็บเงินไม่ได้')
        }
      }, function (error) {
        console.log(error);
        _this3.openCashBox(data);
        // alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
      });
    },
    doingNow: function doingNow() {
      this.alert_msg('warning', 'แจ้งเตือนระบบ', 'ระบบกำลังพัฒนา');
    },
    dateYearThai: function dateYearThai(date) {
      return moment(date).format('YYYY');
    },
    dateMonth: function dateMonth(date) {
      return moment(date).format('YYYY-MM');
    },
    alert_msg: function alert_msg(type, title, text) {
      this.$notice[type]({
        title: title,
        description: text
      });
    },
    dateFormat: function dateFormat(date) {
      return moment(date).format('L');
    },
    dateTimeFormatDMY: function dateTimeFormatDMY(date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss');
    },
    dateTimeHHMMSS: function dateTimeHHMMSS(date) {
      return moment(date).format('HH:mm:ss');
    },
    dateDMY: function dateDMY(date) {
      return moment(date).format('YYYYMMDD');
    },
    dateFormatDMY: function dateFormatDMY(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    dateFormatDMY2: function dateFormatDMY2(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    dateFormatMY: function dateFormatMY(date) {
      return moment(date).format('MM/YYYY');
    },
    monthFormat: function monthFormat(str) {
      switch (str) {
        case '01':
          return 'ม.ค';
        case '02':
          return 'ก.พ';
        case '03':
          return 'มี.ค';
        case '04':
          return 'เม.ย';
        case '05':
          return 'พ.ค';
        case '06':
          return 'มิ.ย';
        case '07':
          return 'ก.ค';
        case '08':
          return 'ส.ค';
        case '09':
          return 'ก.ย';
        case '10':
          return 'ต.ค';
        case '11':
          return 'พ.ย';
        default:
          return 'ธ.ค';
      }
    },
    monthYearFormat: function monthYearFormat(str) {
      var date = str.split('-');
      switch (date[1]) {
        case '01':
          return 'มกราคม ' + date[0];
        case '02':
          return 'กุมภาพันธ์ ' + date[0];
        case '03':
          return 'มีนาคม ' + date[0];
        case '04':
          return 'เมษายน ' + date[0];
        case '05':
          return 'พฤษภาคม ' + date[0];
        case '06':
          return 'มิถุนายน ' + date[0];
        case '07':
          return 'กรกฎาคม ' + date[0];
        case '08':
          return 'สิงหาคม ' + date[0];
        case '09':
          return 'กันยายน ' + date[0];
        case '10':
          return 'ตุลาคม ' + date[0];
        case '11':
          return 'พฤศจิกายน ' + date[0];
        default:
          return 'ธันวาคม ' + date[0];
      }
    },
    numberFormatThenZero: function numberFormatThenZero(str) {
      if (parseFloat(str) > 0) {
        return numeral(str).format('0,0');
      } else {
        return numeral('0').format('0,0');
      }
    },
    numberFormat: function numberFormat(str) {
      return numeral(str).format('0,0');
    },
    numberFormatDecimal: function numberFormatDecimal(str) {
      return numeral(str).format('0,0.00');
    },
    moneyText: function moneyText(str) {
      return ThaiBaht(str);
    },
    convert_vs: function convert_vs(val) {
      var data = [];
      var len = 3;
      if (val.length > 3) {
        len = val.length;
      }
      var vallen = val.length;
      for (var i = 0; i < len; i++) {
        var v = val.split('');
        if (len - i === vallen) {
          var ss = len - i;
          if (ss === vallen) {
            if (val.length === 1) {
              data.push(val);
            } else {
              if (len > val.length) {
                data.push(v[i - 1]);
              } else {
                data.push(v[i]);
              }
            }
          } else {
            data.push(v[i - 1]);
          }
          vallen--;
        } else {
          data.push('0');
        }
      }
      var versions = '';
      for (var l = 0; l < data.length; l++) {
        versions += data[l];
        if (l < data.length - 1) {
          versions += '.';
        }
      }
      return versions;
    },
    getParam: function getParam(param) {
      var url = new URL(window.location.href);
      var c = url.searchParams.get(param);
      return c;
    },
    convertTitleCalendar: function convertTitleCalendar(str) {
      var date = str.split(' ');
      switch (date[0]) {
        case 'มกราคม':
          return '01-' + date[1];
        case 'กุมภาพันธ์':
          return '02-' + date[1];
        case 'มีนาคม':
          return '03-' + date[1];
        case 'เมษายน':
          return '04-' + date[1];
        case 'พฤษภาคม':
          return '05-' + date[1];
        case 'มิถุนายน':
          return '06-' + date[1];
        case 'กรกฎาคม':
          return '07-' + date[1];
        case 'สิงหาคม':
          return '08-' + date[1];
        case 'กันยายน':
          return '09-' + date[1];
        case 'ตุลาคม':
          return '10-' + date[1];
        case 'พฤศจิกายน':
          return '11-' + date[1];
        default:
          return '12-' + date[1];
      }
    },
    colorItemDefalt: function colorItemDefalt(val) {
      switch (val) {
        case 0:
          return 'white';
        case 1:
          return 'green';
        default:
          return 'white';
      }
    }
  }
});

/***/ }),

/***/ 1012:
/***/ (function(module, exports) {

module.exports = {"api":"https://rice-ipad.maeriminterfood.com/","api_pro":"https://rice-ipad.maeriminterfood.com/","printer_url":"moshihome.thddns.net:3331"}

/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  created: function created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize: function handleResize() {
      this.$store.state.screenWidth = window.innerWidth;
      this.$store.state.screenHeight = window.innerHeight;
    }
  }
});

/***/ }),

/***/ 498:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  addSale: function addSale(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  UpdateSale: function UpdateSale(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/update', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdBill: function holdBill(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/holdbill', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  openShift: function openShift(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/open', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  closeShift: function closeShift(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/close', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  closeShiftUpdate: function closeShiftUpdate(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/update', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getHostShift: function getHostShift(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get(URL + 'company/v1/host/list', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getHostShiftDetail: function getHostShiftDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/details', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  billList: function billList(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  billPosList: function billPosList(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/history/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printBill: function printBill(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/cash/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printHolding: function printHolding(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/hold/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printBillCredit: function printBillCredit(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/credit/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printPaybill: function printPaybill(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/paybill/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getSaleOnHost: function getSaleOnHost(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/report/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  cancelBill: function cancelBill(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getHoldingBill: function getHoldingBill(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/holdbill/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  ExportMoney: function ExportMoney(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/expense/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  ImportMoney: function ImportMoney(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/income/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  PrintCloseShif: function PrintCloseShif(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/shift/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  openCashBox: function openCashBox(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/open/cashbox', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveList: function receiveList(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveCancel: function receiveCancel(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveById: function receiveById(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/id', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  billCreditList: function billCreditList(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/bill/receipt/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveNew: function receiveNew(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiveUpdate: function receiveUpdate(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/creditnote/update', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiptSearch: function receiptSearch(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiptDetail: function receiptDetail(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/id', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  receiptDel: function receiptDel(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  payBillCredit: function payBillCredit(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  printPayBillCredit: function printPayBillCredit(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getPosByDoc: function getPosByDoc(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/paybill/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getPosList: function getPosList(URL, body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/return/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  configDetail: function configDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/branch/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  billCreditDetail: function billCreditDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/print/data', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  billReceiptDetail: function billReceiptDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'customer/v1/receipt/id', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  slipExpend: function slipExpend(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/expense/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  slipIncome: function slipIncome(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/income/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  checkReturn: function checkReturn(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/check/return', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  changeSlip: function changeSlip(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/change/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  checkOpenShift: function checkOpenShift(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/shift/open/now', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_store__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ant_design_vue__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ant_design_vue_dist_antd_css__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ant_design_vue_dist_antd_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ant_design_vue_dist_antd_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_index_css__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_css_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_js_mixin__ = __webpack_require__(1011);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_ant_design_vue__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 510:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(190);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a64a4b0a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(511);
var normalizeComponent = __webpack_require__(494)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a64a4b0a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 511:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('a-spin',{attrs:{"tip":"กำลังโหลดข้อมูล...","spinning":_vm.$store.state.isLoading,"size":"large"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 512:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(513);


var Full = function Full() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1018));
};
var Login = function Login() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1019));
};
var POS = function POS() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1020));
};
var Order = function Order() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1021));
};
var page404 = function page404() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1022));
};

var Main = function Main() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1023));
};
var Setting = function Setting() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1024));
};
var MainReport = function MainReport() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1025));
};
var ReportSale = function ReportSale() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1026));
};
var MainStore = function MainStore() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1027));
};
var UserList = function UserList() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1028));
};
var ManageUser = function ManageUser() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1029));
};
var Vendor = function Vendor() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1030));
};
var Customer = function Customer() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1031));
};
var Calendar = function Calendar() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1032));
};
var ItemList = function ItemList() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1033));
};
var ManageItem = function ManageItem() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1034));
};
var ManageCategory = function ManageCategory() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1035));
};
var ManageStorage = function ManageStorage() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1036));
};
var ReceiveList = function ReceiveList() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1037));
};
var ReturnList = function ReturnList() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1038));
};
var ReportExpend = function ReportExpend() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1039));
};
var ReportCostSale = function ReportCostSale() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1040));
};
var ReportSaleItem = function ReportSaleItem() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1041));
};
var ReportProductMovement = function ReportProductMovement() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1042));
};
var ReportStock = function ReportStock() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1043));
};
var ReportStockEgg = function ReportStockEgg() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1044));
};
var AdjustItem = function AdjustItem() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1045));
};
var TranformItem = function TranformItem() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1046));
};
var Reprintsale = function Reprintsale() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1047));
};

var originalPush = __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */].prototype.push;
__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */].prototype.push = function push(location) {
  return originalPush.call(this, location).catch(function (err) {
    return err;
  });
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var titlename = ' | POS';

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  base: __dirname,
  routes: [{
    path: '/',
    redirect: '/',
    name: 'full',
    component: Full,
    children: [{
      path: '/',
      name: 'main',
      component: Main,
      meta: { title: 'หน้าแรก' }
    }, {
      path: '/setting',
      name: 'setting',
      component: Setting,
      meta: { title: 'ตั้งค่าระบบ' }
    }, {
      path: '/reports',
      name: 'main_report',
      component: MainReport,
      meta: { title: 'รายงาน' }
    }, {
      path: '/report_sale',
      name: 'report_sale',
      component: ReportSale,
      meta: { title: 'รายงานยอดขายประจำวัน' }
    }, {
      path: '/vendor',
      name: 'vendor',
      component: Vendor,
      meta: { title: 'จัดการข้อมูลเจ้าหนี้' }
    }, {
      path: '/customer',
      name: 'customer',
      component: Customer,
      meta: { title: 'จัดการข้อมูลลูกหนี้' }
    }, {
      path: '/calendar',
      name: 'calendar',
      component: Calendar,
      meta: { title: 'ปฏิทินนัดหมาย' }
    }, {
      path: '/managestore',
      name: 'main_store',
      component: MainStore,
      meta: { title: 'รายงาน' }
    }, {
      path: '/manageusers',
      name: 'manageusers',
      component: UserList,
      meta: { title: 'รายการผู้ใช้งาน' }
    }, {
      path: '/editusers/:user_code',
      name: 'editusers',
      component: ManageUser,
      meta: { title: 'จัดการผู้ใช้งาน' }
    }, {
      path: '/itemlist',
      name: 'itemlist',
      component: ItemList,
      meta: { title: 'รายการสินค้า' }
    }, {
      path: '/manageitem/:id',
      name: 'manageitem',
      component: ManageItem,
      meta: { title: 'จัดการสินค้า' }
    }, {
      path: '/managecategory',
      name: 'managecategory',
      component: ManageCategory,
      meta: { title: 'จัดการหมวดหมู่' }
    }, {
      path: '/managestorage/:code',
      name: 'managestorage',
      component: ManageStorage,
      meta: { title: 'รับสินค้าเข้า' }
    }, {
      path: '/receivelist',
      name: 'receivelist',
      component: ReceiveList,
      meta: { title: 'รายการรับเข้า' }
    }, {
      path: '/returnlist',
      name: 'returnlist',
      component: ReturnList,
      meta: { title: 'รายการคืนสินค้า' }
    }, {
      path: '/reportexpend',
      name: 'reportexpend',
      component: ReportExpend,
      meta: { title: 'รายงานค่าใช้จ่ายประจำวัน' }
    }, {
      path: '/reportcostsale',
      name: 'reportcostsale',
      component: ReportCostSale,
      meta: { title: 'รายงานต้นทุนสินค้า' }
    }, {
      path: '/reportproductmovement',
      name: 'reportproductmovement',
      component: ReportProductMovement,
      meta: { title: 'รายงานเคลื่อนไหวสินค้า' }
    }, {
      path: '/report_saleitem',
      name: 'report_saleitem',
      component: ReportSaleItem,
      meta: { title: 'รายงานยอดขายตามสินค้า' }
    }, {
      path: '/reportstock',
      name: 'reportstock',
      component: ReportStock,
      meta: { title: 'รายงานสินค้าคงคลัง' }
    }, {
      path: '/reportstockegg',
      name: 'reportstockegg',
      component: ReportStockEgg,
      meta: { title: 'รายงานสินค้าไข่' }
    }, {
      path: '/adjust_item',
      name: 'adjust_item',
      component: AdjustItem,
      meta: { title: 'รายงานต้นทุนสินค้า' }
    }, {
      path: '/tranfrom_item',
      name: 'tranfrom_item',
      component: TranformItem,
      meta: { title: 'รายงานต้นทุนสินค้า' }
    }, {
      path: '/reprintsale',
      name: 'reprintsale',
      component: Reprintsale,
      meta: { title: 'รายการบิลขาย' }
    }]
  }, {
    path: '/pos',
    name: 'POS',
    component: POS,
    meta: { title: 'โปรแกรมขาย' }
  }, {
    path: '/order',
    name: 'Order',
    component: Order,
    meta: { title: 'สั่งสินค้า' }
  }, {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: 'เข้าสู่ระบบ' }
  }, {
    path: '*',
    name: 'P404',
    component: page404,
    meta: { title: 'Error Page' }
  }]
});

var DEFAULT_TITLE = titlename;
router.afterEach(function (to, from) {
  document.title = to.meta.title + titlename || DEFAULT_TITLE + titlename;
});

/* harmony default export */ __webpack_exports__["a"] = (router);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 205,
	"./af.js": 205,
	"./ar": 206,
	"./ar-dz": 207,
	"./ar-dz.js": 207,
	"./ar-kw": 208,
	"./ar-kw.js": 208,
	"./ar-ly": 209,
	"./ar-ly.js": 209,
	"./ar-ma": 210,
	"./ar-ma.js": 210,
	"./ar-sa": 211,
	"./ar-sa.js": 211,
	"./ar-tn": 212,
	"./ar-tn.js": 212,
	"./ar.js": 206,
	"./az": 213,
	"./az.js": 213,
	"./be": 214,
	"./be.js": 214,
	"./bg": 215,
	"./bg.js": 215,
	"./bm": 216,
	"./bm.js": 216,
	"./bn": 217,
	"./bn-bd": 218,
	"./bn-bd.js": 218,
	"./bn.js": 217,
	"./bo": 219,
	"./bo.js": 219,
	"./br": 220,
	"./br.js": 220,
	"./bs": 221,
	"./bs.js": 221,
	"./ca": 222,
	"./ca.js": 222,
	"./cs": 223,
	"./cs.js": 223,
	"./cv": 224,
	"./cv.js": 224,
	"./cy": 225,
	"./cy.js": 225,
	"./da": 226,
	"./da.js": 226,
	"./de": 227,
	"./de-at": 228,
	"./de-at.js": 228,
	"./de-ch": 229,
	"./de-ch.js": 229,
	"./de.js": 227,
	"./dv": 230,
	"./dv.js": 230,
	"./el": 231,
	"./el.js": 231,
	"./en-au": 232,
	"./en-au.js": 232,
	"./en-ca": 233,
	"./en-ca.js": 233,
	"./en-gb": 234,
	"./en-gb.js": 234,
	"./en-ie": 235,
	"./en-ie.js": 235,
	"./en-il": 236,
	"./en-il.js": 236,
	"./en-in": 237,
	"./en-in.js": 237,
	"./en-nz": 238,
	"./en-nz.js": 238,
	"./en-sg": 239,
	"./en-sg.js": 239,
	"./eo": 240,
	"./eo.js": 240,
	"./es": 241,
	"./es-do": 242,
	"./es-do.js": 242,
	"./es-mx": 243,
	"./es-mx.js": 243,
	"./es-us": 244,
	"./es-us.js": 244,
	"./es.js": 241,
	"./et": 245,
	"./et.js": 245,
	"./eu": 246,
	"./eu.js": 246,
	"./fa": 247,
	"./fa.js": 247,
	"./fi": 248,
	"./fi.js": 248,
	"./fil": 249,
	"./fil.js": 249,
	"./fo": 250,
	"./fo.js": 250,
	"./fr": 251,
	"./fr-ca": 252,
	"./fr-ca.js": 252,
	"./fr-ch": 253,
	"./fr-ch.js": 253,
	"./fr.js": 251,
	"./fy": 254,
	"./fy.js": 254,
	"./ga": 255,
	"./ga.js": 255,
	"./gd": 256,
	"./gd.js": 256,
	"./gl": 257,
	"./gl.js": 257,
	"./gom-deva": 258,
	"./gom-deva.js": 258,
	"./gom-latn": 259,
	"./gom-latn.js": 259,
	"./gu": 260,
	"./gu.js": 260,
	"./he": 261,
	"./he.js": 261,
	"./hi": 262,
	"./hi.js": 262,
	"./hr": 263,
	"./hr.js": 263,
	"./hu": 264,
	"./hu.js": 264,
	"./hy-am": 265,
	"./hy-am.js": 265,
	"./id": 266,
	"./id.js": 266,
	"./is": 267,
	"./is.js": 267,
	"./it": 268,
	"./it-ch": 269,
	"./it-ch.js": 269,
	"./it.js": 268,
	"./ja": 270,
	"./ja.js": 270,
	"./jv": 271,
	"./jv.js": 271,
	"./ka": 272,
	"./ka.js": 272,
	"./kk": 273,
	"./kk.js": 273,
	"./km": 274,
	"./km.js": 274,
	"./kn": 275,
	"./kn.js": 275,
	"./ko": 276,
	"./ko.js": 276,
	"./ku": 277,
	"./ku.js": 277,
	"./ky": 278,
	"./ky.js": 278,
	"./lb": 279,
	"./lb.js": 279,
	"./lo": 280,
	"./lo.js": 280,
	"./lt": 281,
	"./lt.js": 281,
	"./lv": 282,
	"./lv.js": 282,
	"./me": 283,
	"./me.js": 283,
	"./mi": 284,
	"./mi.js": 284,
	"./mk": 285,
	"./mk.js": 285,
	"./ml": 286,
	"./ml.js": 286,
	"./mn": 287,
	"./mn.js": 287,
	"./mr": 288,
	"./mr.js": 288,
	"./ms": 289,
	"./ms-my": 290,
	"./ms-my.js": 290,
	"./ms.js": 289,
	"./mt": 291,
	"./mt.js": 291,
	"./my": 292,
	"./my.js": 292,
	"./nb": 293,
	"./nb.js": 293,
	"./ne": 294,
	"./ne.js": 294,
	"./nl": 295,
	"./nl-be": 296,
	"./nl-be.js": 296,
	"./nl.js": 295,
	"./nn": 297,
	"./nn.js": 297,
	"./oc-lnc": 298,
	"./oc-lnc.js": 298,
	"./pa-in": 299,
	"./pa-in.js": 299,
	"./pl": 300,
	"./pl.js": 300,
	"./pt": 301,
	"./pt-br": 302,
	"./pt-br.js": 302,
	"./pt.js": 301,
	"./ro": 303,
	"./ro.js": 303,
	"./ru": 304,
	"./ru.js": 304,
	"./sd": 305,
	"./sd.js": 305,
	"./se": 306,
	"./se.js": 306,
	"./si": 307,
	"./si.js": 307,
	"./sk": 308,
	"./sk.js": 308,
	"./sl": 309,
	"./sl.js": 309,
	"./sq": 310,
	"./sq.js": 310,
	"./sr": 311,
	"./sr-cyrl": 312,
	"./sr-cyrl.js": 312,
	"./sr.js": 311,
	"./ss": 313,
	"./ss.js": 313,
	"./sv": 314,
	"./sv.js": 314,
	"./sw": 315,
	"./sw.js": 315,
	"./ta": 316,
	"./ta.js": 316,
	"./te": 317,
	"./te.js": 317,
	"./tet": 318,
	"./tet.js": 318,
	"./tg": 319,
	"./tg.js": 319,
	"./th": 320,
	"./th.js": 320,
	"./tk": 321,
	"./tk.js": 321,
	"./tl-ph": 322,
	"./tl-ph.js": 322,
	"./tlh": 323,
	"./tlh.js": 323,
	"./tr": 324,
	"./tr.js": 324,
	"./tzl": 325,
	"./tzl.js": 325,
	"./tzm": 326,
	"./tzm-latn": 327,
	"./tzm-latn.js": 327,
	"./tzm.js": 326,
	"./ug-cn": 328,
	"./ug-cn.js": 328,
	"./uk": 329,
	"./uk.js": 329,
	"./ur": 330,
	"./ur.js": 330,
	"./uz": 331,
	"./uz-latn": 332,
	"./uz-latn.js": 332,
	"./uz.js": 331,
	"./vi": 333,
	"./vi.js": 333,
	"./x-pseudo": 334,
	"./x-pseudo.js": 334,
	"./yo": 335,
	"./yo.js": 335,
	"./zh-cn": 336,
	"./zh-cn.js": 336,
	"./zh-hk": 337,
	"./zh-hk.js": 337,
	"./zh-mo": 338,
	"./zh-mo.js": 338,
	"./zh-tw": 339,
	"./zh-tw.js": 339
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 541;

/***/ }),

/***/ 551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation__ = __webpack_require__(553);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  user: [],
  token: null,
  screenHeight: 0,
  screenWidth: 0,
  isLoading: false,
  config: {},
  btnbottom: false,
  historyPage: '',
  currentPath: '',
  order_data: {
    'host_code': '',
    'ar_code': '',
    'tax_rate': 7,
    'discount_word': '',
    'discount_amount': 0,
    'item_amount': 0,
    'bill_type': 0,
    'cash_amount': 0,
    'credit_card_amount': 0,
    'sub': []
  },
  item_subs: [],
  detail_pop: {},
  receive_show: false,
  transfer_id: {},
  transfer_detail: {},
  isBranchTransfer: false,
  tool_type: 0,
  activity_detail: {}
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutation__,
  state: state
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["clearState"] = clearState;
/* harmony export (immutable) */ __webpack_exports__["clearOrderPayment"] = clearOrderPayment;
/* harmony export (immutable) */ __webpack_exports__["Loading"] = Loading;
function clearState(state) {
  state.user = [];
  sessionStorage.clear();
}

function clearOrderPayment(state) {
  state.order_data = {
    'host_code': '',
    'ar_code': '',
    'tax_rate': 7,
    'discount_word': '',
    'discount_amount': 0,
    'item_amount': 0,
    'bill_type': 0,
    'cash_amount': 0,
    'credit_card_amount': 0,
    'sub': []
  };
  state.item_subs = [];
}

function Loading(state) {
  state.isLoading = !state.isLoading;
}

/***/ }),

/***/ 989:
/***/ (function(module, exports) {

module.exports = {"name":"ant-design-vue","version":"1.7.8","title":"Ant Design Vue","description":"An enterprise-class UI design language and Vue-based implementation","keywords":["ant","design","antd","vue","vueComponent","component","components","ui","framework","frontend"],"main":"lib/index.js","module":"es/index.js","typings":"types/index.d.ts","files":["dist","lib","es","types","scripts"],"scripts":{"dev":"webpack-dev-server","start":"cross-env NODE_ENV=development webpack-dev-server --config webpack.config.js","test":"cross-env NODE_ENV=test jest --config .jest.js","compile":"node antd-tools/cli/run.js compile","pub":"node antd-tools/cli/run.js pub","pub-with-ci":"node antd-tools/cli/run.js pub-with-ci","prepublish":"node antd-tools/cli/run.js guard","pre-publish":"node ./scripts/prepub","prettier":"prettier -c --write '**/*'","pretty-quick":"pretty-quick","dist":"node antd-tools/cli/run.js dist","lint":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue ./components","lint:site":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue ./antdv-demo","lint:docs":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue,.md ./antdv-demo/docs/**/demo/**","lint:style":"stylelint \"{site,components}/**/*.less\" --syntax less","codecov":"codecov","postinstall":"node scripts/postinstall || echo \"ignore\""},"repository":{"type":"git","url":"git+https://github.com/vueComponent/ant-design-vue.git"},"license":"MIT","bugs":{"url":"https://github.com/vueComponent/ant-design-vue/issues"},"homepage":"https://www.antdv.com/","peerDependencies":{"vue":"^2.6.0","vue-template-compiler":"^2.6.0"},"devDependencies":{"@commitlint/cli":"^8.0.0","@commitlint/config-conventional":"^8.0.0","@octokit/rest":"^16.0.0","@vue/cli-plugin-eslint":"^4.0.0","@vue/server-test-utils":"1.0.0-beta.16","@vue/test-utils":"1.0.0-beta.16","acorn":"^7.0.0","autoprefixer":"^9.6.0","axios":"^0.19.0","babel-cli":"^6.26.0","babel-core":"^6.26.0","babel-eslint":"^10.0.1","babel-helper-vue-jsx-merge-props":"^2.0.3","babel-jest":"^23.6.0","babel-loader":"^7.1.2","babel-plugin-import":"^1.1.1","babel-plugin-inline-import-data-uri":"^1.0.1","babel-plugin-istanbul":"^6.0.0","babel-plugin-syntax-dynamic-import":"^6.18.0","babel-plugin-syntax-jsx":"^6.18.0","babel-plugin-transform-class-properties":"^6.24.1","babel-plugin-transform-decorators":"^6.24.1","babel-plugin-transform-decorators-legacy":"^1.3.4","babel-plugin-transform-es3-member-expression-literals":"^6.22.0","babel-plugin-transform-es3-property-literals":"^6.22.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-object-rest-spread":"^6.26.0","babel-plugin-transform-runtime":"~6.23.0","babel-plugin-transform-vue-jsx":"^3.7.0","babel-polyfill":"^6.26.0","babel-preset-env":"^1.6.1","case-sensitive-paths-webpack-plugin":"^2.1.2","chalk":"^3.0.0","cheerio":"^1.0.0-rc.2","codecov":"^3.0.0","colorful":"^2.1.0","commander":"^4.0.0","compare-versions":"^3.3.0","cross-env":"^7.0.0","css-loader":"^3.0.0","deep-assign":"^2.0.0","enquire-js":"^0.2.1","eslint":"^6.8.0","eslint-config-prettier":"^6.10.1","eslint-plugin-html":"^6.0.0","eslint-plugin-markdown":"^2.0.0-alpha.0","eslint-plugin-vue":"^6.2.2","fetch-jsonp":"^1.1.3","fs-extra":"^8.0.0","glob":"^7.1.2","gulp":"^4.0.1","gulp-babel":"^7.0.0","gulp-strip-code":"^0.1.4","html-webpack-plugin":"^3.2.0","husky":"^4.0.0","istanbul-instrumenter-loader":"^3.0.0","jest":"^24.0.0","jest-serializer-vue":"^2.0.0","jest-transform-stub":"^2.0.0","js-base64":"^3.0.0","json-templater":"^1.2.0","jsonp":"^0.2.1","less":"^3.9.0","less-loader":"^6.0.0","less-plugin-npm-import":"^2.1.0","lint-staged":"^10.0.0","marked":"0.3.18","merge2":"^1.2.1","mini-css-extract-plugin":"^0.10.0","minimist":"^1.2.0","mkdirp":"^0.5.1","mockdate":"^2.0.2","nprogress":"^0.2.0","optimize-css-assets-webpack-plugin":"^5.0.1","postcss":"^7.0.6","postcss-loader":"^3.0.0","prettier":"^1.18.2","pretty-quick":"^2.0.0","querystring":"^0.2.0","raw-loader":"^4.0.0","reqwest":"^2.0.5","rimraf":"^3.0.0","rucksack-css":"^1.0.2","selenium-server":"^3.0.1","semver":"^7.0.0","style-loader":"^1.0.0","stylelint":"^13.0.0","stylelint-config-prettier":"^8.0.0","stylelint-config-standard":"^19.0.0","terser-webpack-plugin":"^3.0.3","through2":"^3.0.0","url-loader":"^3.0.0","vue":"^2.6.11","vue-antd-md-loader":"^1.1.0","vue-clipboard2":"0.3.1","vue-draggable-resizable":"^2.1.0","vue-eslint-parser":"^7.0.0","vue-i18n":"^8.3.2","vue-infinite-scroll":"^2.0.2","vue-jest":"^2.5.0","vue-loader":"^15.6.2","vue-router":"^3.0.1","vue-server-renderer":"^2.6.11","vue-template-compiler":"^2.6.11","vue-virtual-scroller":"^1.0.0","vuex":"^3.1.0","webpack":"^4.28.4","webpack-cli":"^3.2.1","webpack-dev-server":"^3.1.14","webpack-merge":"^4.1.1","webpackbar":"^4.0.0","xhr-mock":"^2.5.1"},"dependencies":{"@ant-design/icons":"^2.1.1","@ant-design/icons-vue":"^2.0.0","@simonwep/pickr":"~1.7.0","add-dom-event-listener":"^1.0.2","array-tree-filter":"^2.1.0","async-validator":"^3.0.3","babel-helper-vue-jsx-merge-props":"^2.0.3","babel-runtime":"6.x","classnames":"^2.2.5","component-classes":"^1.2.6","dom-align":"^1.10.4","dom-closest":"^0.2.0","dom-scroll-into-view":"^2.0.0","enquire.js":"^2.1.6","intersperse":"^1.0.0","is-mobile":"^2.2.1","is-negative-zero":"^2.0.0","ismobilejs":"^1.0.0","json2mq":"^0.2.0","lodash":"^4.17.5","moment":"^2.21.0","mutationobserver-shim":"^0.3.2","node-emoji":"^1.10.0","omit.js":"^1.0.0","raf":"^3.4.0","resize-observer-polyfill":"^1.5.1","shallow-equal":"^1.0.0","shallowequal":"^1.0.2","vue-ref":"^2.0.0","warning":"^4.0.0"},"sideEffects":["site/*","components/style.js","components/**/style/*","*.vue","*.md","dist/*","es/**/style/*","lib/**/style/*","*.less"]}

/***/ })

},[507]);


// WEBPACK FOOTER //
// static/js/app.66c04beb948a8b4044bd.js